<div class="auth-layout">
  <div class="auth-shell">
    <section class="auth-brand">
      <div class="auth-brand__content">
        

        
        <h1>SHRI KRISHNA ENGINEERING WORKS</h1>
        <p class="auth-brand__description">
          Inspection control, rejection monitoring, and production visibility in one secure workspace.
        </p>

        <div class="auth-brand__points">
          <div class="auth-brand__point">
            <i class='bx bx-check-shield'></i>
            <span>Secure access for approved employees</span>
          </div>

          <div class="auth-brand__point">
            <i class='bx bx-line-chart'></i>
            <span>Real-time monitoring of quality and rejection flow</span>
          </div>

          <div class="auth-brand__point">
            <i class='bx bx-git-branch'></i>
            <span>Operational visibility across daily shop-floor processes</span>
          </div>
        </div>
      </div>

      <div class="auth-brand__summary">
        <div class="auth-brand__summary-head">
          <span>Plant Operations</span>
          <strong>Connected dashboard access</strong>
        </div>

        <div class="auth-brand__summary-grid">
          <div>
            <strong>Inspection</strong>
            <span>Monitor approvals and open checkpoints</span>
          </div>

          <div>
            <strong>Rejection</strong>
            <span>Track movement, trends, and root causes</span>
          </div>

          <div>
            <strong>Production</strong>
            <span>Keep daily status visible to key teams</span>
          </div>
        </div>
      </div>
    </section>

    <section class="auth-panel">
      <div class="auth-panel__shell">
        <router-outlet></router-outlet>
      </div>
    </section>
  </div>
</div>
